import React from "react";
import styles from "./Dots.module.scss"; // or your dots styles

const Dots = ({ visibleDots, currentIndex, goToSlide }) => {
  return (
    <div className={styles.dotsContainer}>
      {visibleDots.map((dotIndex) => (
        <span
          key={dotIndex}
          onClick={() => goToSlide(dotIndex)}
          className={`${styles.dot} ${dotIndex === currentIndex ? styles.active : ""}`}
        />
      ))}
    </div>
  );
};

export default Dots;
